// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import '../styles/navbar.css';

export default function Navbar() {
  const { totalItems } = useCart();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [buscar, setBuscar] = useState('');
  const clienteToken = localStorage.getItem('wawita_cliente_token');

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const isActive = (path) => location.pathname === path;

  const handleBuscar = (e) => {
    if (e.key === 'Enter' && buscar.trim()) {
      window.location.href = `/?q=${encodeURIComponent(buscar.trim())}`;
    }
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
        <div className="navbar-container">
          {/* Logo */}
          <Link to="/" className="navbar-logo">
            <img src="https://res.cloudinary.com/dcbd2vdzn/image/upload/v1777340903/logo_wawita2_tge5t4.png" alt="Wawita Eco Friendly" style={{ height:52, width:'auto', objectFit:'contain' }} />
          </Link>

          {/* Menu desktop */}
          <div className="navbar-menu desktop">
            <Link to="/"                     className={`nav-link ${isActive('/') ? 'active' : ''}`}>Inicio</Link>
            <Link to="/nuestra-historia"     className={`nav-link ${isActive('/nuestra-historia') ? 'active' : ''}`}>Nosotros</Link>
            <Link to="/noticias"             className={`nav-link ${isActive('/noticias') ? 'active' : ''}`}>Noticias</Link>
            <Link to="/sistema-refill"       className={`nav-link ${isActive('/sistema-refill') ? 'active' : ''}`}>Refill</Link>
            <Link to="/contacto"             className={`nav-link ${isActive('/contacto') ? 'active' : ''}`}>Contacto</Link>
            <Link to="/pqrs"                  className={`nav-link ${isActive('/pqrs') ? 'active' : ''}`}>PQRs</Link>
          </div>

          {/* Buscador */}
          <div className="search-bar-nav">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
              <path d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <input placeholder="Buscar productos..." value={buscar} onChange={e => setBuscar(e.target.value)} onKeyDown={handleBuscar} />
          </div>

          {/* Acciones */}
          <div className="navbar-actions">
            {/* Mi cuenta */}
            <Link to="/mi-cuenta" style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, color:'#4a5b4a', fontWeight:600, padding:'6px 12px', borderRadius:8, background: clienteToken ? '#e8f3e6' : 'var(--cream-dark)', textDecoration:'none', transition:'all 0.2s' }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
              </svg>
              {clienteToken ? 'Mi cuenta' : 'Ingresar'}
            </Link>

            {/* Carrito */}
            <Link to="/carrito" className="cart-btn">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.7 15.3C4.1 15.9 4.5 17 5.4 17H17M17 17C15.9 17 15 17.9 15 19C15 20.1 15.9 21 17 21C18.1 21 19 20.1 19 19C19 17.9 18.1 17 17 17ZM9 19C9 20.1 8.1 21 7 21C5.9 21 5 20.1 5 19C5 17.9 5.9 17 7 17C8.1 17 9 17.9 9 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              {totalItems > 0 ? <span className="cart-badge">{totalItems}</span> : null}
            </Link>

            <button className="menu-toggle" onClick={() => setMenuOpen(o => !o)}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Menu movil */}
      {menuOpen && (
        <div className="mobile-menu">
          <Link to="/">Inicio</Link>
          <Link to="/nuestra-historia">Nuestra historia</Link>
          <Link to="/compromiso-ambiental">Compromiso ambiental</Link>
          <Link to="/sistema-refill">Sistema Refill</Link>
          <Link to="/noticias">Noticias</Link>
          <Link to="/contacto">Contacto</Link>
          <Link to="/pqrs">PQRs</Link>
          <Link to="/mi-cuenta">{clienteToken ? 'Mi cuenta' : 'Ingresar / Registrarse'}</Link>
          <Link to="/carrito">Carrito ({totalItems})</Link>
        </div>
      )}
    </>
  );
}
